import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ErrorView from '../../components/ErrorView'
import LoadingScreen from '../../components/LoadingScreen'
import PosTaskActivityReportView from './PosTaskActivityReportView'

const PosTaskApp = () => {
  const { id } = useParams()
  const [isFetching, setIsFetching] = useState(true)
  const [error, setError] = useState(null)
  const [defaultDetails, setDefaultDetails] = useState(null)

  const fetchTransactionDetails = useCallback(() => {
    setIsFetching(true)
    authFetch(`${BASE_BACKEND_URL}/pos_task_activities/${id}`, { method: 'GET' })
      .then((response) => {
        if (!response) return
        if (response.status === 404) {
          return { error: true, message: 'No se encontró la tarea' }
        }
        return response.json()
      })
      .then((data) => {
        if (!data) return
        if (data.error) {
          setError(data.message)
        } else {
          setDefaultDetails(data)
        }
        setIsFetching(false)
      })
      .catch((e) => {
        console.log(e)
        setIsFetching(false)
      })
  }, [id])

  useEffect(() => {
    fetchTransactionDetails()
  }, [fetchTransactionDetails])

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  }

  if (error) {
    return <ErrorView error={error} />
  }

  return <PosTaskActivityReportView activity={defaultDetails} />
}

export default PosTaskApp
